var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            { attrs: { span: "3" } },
            [
              _c(
                "Content",
                { style: { height: _vm.maxHeight } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "table",
                      attrs: {
                        data: _vm.typeData,
                        "highlight-current-row": "",
                        "highlight-selection-row": "",
                        "show-header": false,
                        "max-height": _vm.maxHeight,
                        "row-class-name": _vm.tableRowClassName,
                      },
                      on: { "row-click": _vm.handleRowClick },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "name",
                          "show-overflow-tooltip": "",
                          "max-width": "50",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            { attrs: { span: "21" } },
            [
              _c("DevelopStandardManageList", {
                ref: "developStandardManageList",
                style: { "overflow-y": "auto", "box-sizing": "border-box" },
                attrs: {
                  currentRowIndex: _vm.currentRowIndex,
                  type: _vm.type,
                  sex: _vm.sex,
                  standard: _vm.standard,
                },
                on: {
                  "update:type": function ($event) {
                    _vm.type = $event
                  },
                  "update:sex": function ($event) {
                    _vm.sex = $event
                  },
                  "update:standard": function ($event) {
                    _vm.standard = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }